"use client";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Form } from "@/components/ui/form";
import CustomHeaderInput from "../generator/fields/CustomHeaderInput";

type Props = {
  term?: string;
  admin: boolean;
};

const FormSchema = z.object({
  term: z.string().min(3, {
    message: "Der Name muss mindestens 3 Zeichen lang sein.",
  }),
});
const ObituaryHeaderSearch = ({ term, admin }: Props) => {
  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      term: term ? term : "",
    },
  });

  const router = useRouter();

  function onSubmit(data: z.infer<typeof FormSchema>) {
    if (!admin) {
      router.push(`/traueranzeigen/search/${data.term}`);
    } else {
      if (data.term) {
        window.location.href = `/traueranzeigen/admin/?search=${data.term}`;
      } else {
        window.location.href = `/traueranzeigen/admin/`;
      }
    }
  }

  return (
    <div className="mx-auto flex w-full flex-row pt-16">
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="mx-auto flex w-full max-w-[400px] flex-row items-center justify-center gap-4 space-y-6"
        >
          <CustomHeaderInput
            form={form}
            name="term"
            label=""
            placeholder="Suche mit Name"
          />
          <button
            type="submit"
            id="submit-search"
            className="button large secondary solid-white group !my-auto mx-auto !h-10 !w-10 min-w-[40px] rounded-full !p-0 text-center text-secondary-200"
          >
            <svg
              width="14"
              height="20"
              viewBox="0 0 14 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-0.5 h-2 w-2 stroke-current text-secondary-500"
            >
              <path
                d="M2 23.2059L11.5536 12.7582L2 2.31054"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </form>
      </Form>
    </div>
  );
};

export default ObituaryHeaderSearch;
